import React, { useState, useEffect, useRef, forwardRef } from 'react';
import MainPageCompenent from './MainPageCompenent';
import axios from 'axios'
import 'leaflet/dist/leaflet.css';
import Grid from '@mui/material/Grid';
import MerchantSearch from './MerchantSearch';
import { getAuthenticationToken } from '../utils/TokenHandler';
import MaterialNotifyComponent from './MaterialNotifyComponent';
import LeafletMapComponent from './LeafletMapComponent';
import { Backdrop, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, useMediaQuery } from '@mui/material';
import { useTheme } from 'styled-components';

function MerchantMap(props) {
    const [merchantMarkers, setMerchantMarkers] = useState([]);
    const [merchantMarkersCount, setMerchantMarkersCount] = useState(0);
    const [messageNotify, setMessageNotify] = useState({ severity: "warning", message: "", open: false });
    const [page, setPage] = useState(1);
    const [searchText, setSearchText] = useState('');
    const [position, setPosition] = useState([35.71195799643195, 51.38574763177731]);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (!("geolocation") in navigator) {
            setPosition([35.71195799643195, 51.38574763177731])
        }
        navigator.geolocation.getCurrentPosition(
            (location) => setPosition([location.coords.latitude, location.coords.longitude]),
            () => {
                setPosition([35.71195799643195, 51.38574763177731])
            })
    }, []);


    const AddMerchantLocations = (locations) => {
        if (locations.length > 0) {
            try {
                const latlng = { lat: locations[0].lat, lng: locations[0].lng }
                //map.flyTo(latlng, 13)
            }
            catch (e) {
            }
        }
        setMerchantMarkers(locations)
    };

    const onSearchMerchant = (searchItem) => {
        setPage(searchItem.page);
        if (searchItem.showNearest) {
            setSearchText('');
            setOpen(true);
            axios.get('api/v1/Company/GetNeareastMerchantsV4', {
                params: {
                    customerId: getAuthenticationToken().userID,
                    latitude: position[0],
                    longitude: position[1],
                    distance: 5,
                    clubId: getAuthenticationToken().clubId,
                    take: 5,
                    skip: ((searchItem.page - 1) * 5)
                }
            }).then((response) => {
                AddMerchantLocations(response.data.merchantNearestList.map(
                    (merchant) => {
                        return {
                            name: merchant.name,
                            lat: merchant.lat,
                            lng: merchant.long,
                            guildName: merchant.guildName,
                            address: merchant.address,
                            allData: merchant
                        }
                    })
                );
                setMerchantMarkersCount(response.data.count);
            }).catch(e => {
                setMessageNotify({
                    severity: "error",
                    message: "خطا در فرواخوانی اطلاعات پذیرندگان ",
                    open: true
                })
            }).finally(() => setOpen(false))
        }
        else {
            setSearchText(searchItem.filterText);            
            setOpen(true);
            axios.get('api/v1/Company/GetMerchantsBySearchV3', {
                params: {
                    customerId: getAuthenticationToken().userID,
                    clubId: getAuthenticationToken().clubId,
                    SearchString: searchItem.filterText,
                    take: 5,
                    skip: ((searchItem.page - 1) * 5)
                }
            }).then((response) => {
                AddMerchantLocations(response.data.merchantNearestList.map(
                    (merchant) => {
                        return {
                            name: merchant.name,
                            lat: merchant.lat,
                            lng: merchant.long,
                            guildName: merchant.guildName,
                            address: merchant.address,
                            allData: merchant
                        }
                    })
                );
                setMerchantMarkersCount(response.data.count);
            }).catch(e => {
                setMessageNotify({
                    severity: "error",
                    message: "خطا در فرواخوانی اطلاعات پذیرندگان ",
                    open: true
                })
            }).finally(() => setOpen(false))
        }
    };

    const [openDialog, setOpenDialog] = React.useState({ open: false, data: null });

    const handleDialogOpen = (merchant) => {
        setOpenDialog({ open: true, data: merchant });
    };

    const handleDialogClose = () => {
        setOpenDialog({ ...openDialog, open: false });
    };

    return (
        <MainPageCompenent>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={9} lg={9} md={9} xl={9}>
                    <LeafletMapComponent position={position} merchantMarkers={merchantMarkers} handleDialogOpen={handleDialogOpen} />
                </Grid>
                <Grid item xs={12} sm={3} lg={3} md={3} xl={3}>
                    <MerchantSearch handleDialogOpen={handleDialogOpen} onSearch={onSearchMerchant} merchantMarkers={merchantMarkers} merchantMarkersCount={merchantMarkersCount} page={page} searchText={searchText} />
                </Grid>
            </Grid>
            <MaterialNotifyComponent open={messageNotify.open} severity={messageNotify.severity} message={messageNotify.message} />
            <Dialog
                style={{ direction: 'rtl' }}
                open={openDialog.open}
                onClose={handleDialogClose}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle id="responsive-dialog-title">
                    {openDialog.data ? openDialog.data.name : ''}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <b>کد: </b> {openDialog.data ? openDialog.data.allData.code : ''} <br />
                        <b>صنف: </b>{openDialog.data ? openDialog.data.allData.guildName : ''} <br />
                        <b>شرکت: </b>{openDialog.data ? openDialog.data.allData.companyName : ''} <br />
                        <b>آدرس: </b>{openDialog.data ? openDialog.data.allData.address : ''} <br />
                        <b>توضیحات: </b>{openDialog.data ? openDialog.data.allData.description : ''}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={handleDialogClose}>
                        بستن
                    </Button>
                </DialogActions>
            </Dialog>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={open}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </MainPageCompenent>

    );
}
export default MerchantMap